import React from 'react'
import ProTeacherMyCourses from '../../features/proteacher/ProTeacherMyCourses'

const ProTeacherMyCoursesPage = () => {
  return (
   <ProTeacherMyCourses/>
  )
}

export default ProTeacherMyCoursesPage
